import { PropsWithChildren } from 'react';
import * as Sentry from '@sentry/react';
import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { Icon } from '../atomic';
import * as S from './ErrorBoundaryLayout/ErrorBoundaryLayout.styled';

export default function ChatListErrorBoundary({
  children,
}: PropsWithChildren<unknown>) {
  const { reset } = useQueryErrorResetBoundary();
  return (
    <Sentry.ErrorBoundary
      onReset={reset}
      fallback={({ resetError }) => (
        <S.Container>
          <S.InfoBox>
            <p>
              SERVER ERROR <br /> failed get chat list
            </p>
          </S.InfoBox>
          <S.ButtonBox>
            <S.Button onClick={() => resetError()}>
              <Icon size={20} iconName='Reset' />
              <span>retry</span>
            </S.Button>
          </S.ButtonBox>
        </S.Container>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
